import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { combineLatest } from 'rxjs';
import { AbstractTuiControl } from '@taiga-ui/legacy';
import { TuiSizeL, TuiSizeS } from '@taiga-ui/core';
import { ViewMode } from '@src/models';

import {
  CategoriesStoreKeys,
  LoyaltyProgramFilterService,
  LpCategoriesStoreService,
  LpUserProfileService,
} from '../../services';

@Component({
  selector: 'lp-categories-field',
  templateUrl: './categories-field.component.html',
  styleUrls: ['./categories-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoriesFieldComponent extends AbstractTuiControl<string[]> {
  private readonly loyaltyProgramFilterService = inject(LoyaltyProgramFilterService);
  private readonly lpUserProfileService = inject(LpUserProfileService);
  private readonly lpCategoriesStore = inject(LpCategoriesStoreService);

  @Input() mode: ViewMode = 'view';
  @Input() textfieldSize: TuiSizeS | TuiSizeL = 'm';
  @Input() externalLoading = false;

  selectedCategoriesStringify = '';
  innerLoading = false;

  get loading(): boolean {
    return this.innerLoading || this.externalLoading;
  }

  get focused(): boolean {
    return false;
  }

  protected getFallbackValue(): string[] {
    return [];
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.loyaltyProgramFilterService.getCategories(true);

    if (this.control) {
      combineLatest([
        this.lpCategoriesStore.getDataObservable(CategoriesStoreKeys.InUse),
        this.control.valueChanges,
      ]).subscribe(([categories, selectedIds]) => {
        this.innerLoading = !categories;

        if (categories) {
          this.selectedCategoriesStringify = categories
            .filter(category => selectedIds.includes(category.id))
            .map(category => category.name)
            .join('\n');
        }

        this.cdr.markForCheck();
      });

      this.control.setValue(this.value);
    }
  }

  selectCategories() {
    this.lpUserProfileService.showFavoriteCategoriesDialog(this.value).subscribe(favoriteCategories => {
      if (favoriteCategories) {
        this.value = favoriteCategories;
      }
    });
  }
}
